import { Box, Button, Checkbox, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

import FilterCard from "components/pages/dashboard/surgery_types_procedures/filter/cards/FilterCard";
import useMultiSelectFilter from "components/pages/dashboard/surgery_types_procedures/filter/cards/useMultiSelectFilter";

const MultiSelectFilterCard = ({ filter }) => {
  const theme = useTheme();
  const { options, isChecked, toggle, allSelected, toggleAll } =
    useMultiSelectFilter(filter);

  return (
    <FilterCard
      title={filter.label}
      description={filter.description}
      meta={filter.meta}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {options.map((option) => {
          const checked = isChecked(option.value);

          return (
            <Box
              key={String(option.value)}
              component="label"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 1.5,
                py: 0.5,
                cursor: "pointer",
                borderRadius: "6px",
                border: `1px solid ${
                  checked
                    ? theme.palette.secondary.main
                    : theme.palette.border.main
                }`,
                bgcolor: checked
                  ? alpha(theme.palette.secondary.main, 0.12)
                  : "transparent",
              }}
            >
              <Checkbox
                checked={checked}
                color="secondary"
                size="small"
                onChange={() => toggle(option.value)}
                sx={{ p: 0.5 }}
              />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {option.label}
              </Typography>
              {option.description && (
                <Typography
                  variant="caption"
                  sx={{ color: theme.palette.lightText.main }}
                >
                  {`(${option.description})`}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{ color: theme.palette.lightText.main }}
        >
          Multi-select active
        </Typography>
        <Button
          size="small"
          color="secondary"
          onClick={toggleAll}
          sx={{ textTransform: "none", minWidth: 0, p: 0 }}
        >
          {allSelected ? "Clear All" : "Select All"}
        </Button>
      </Box>
    </FilterCard>
  );
};

export default MultiSelectFilterCard;
